// @flow
import React, { Component } from 'react';
import SocialLink from '../SocialLink/SocialLink';


export default class Header extends Component {
    render () {
        return (
            <header>
                <SocialLink />
                <div className="ln-logo">
                    <a
                        href="/">
                        <img
                            src="/logo.png"
                            alt="Laura Nor's Logo" />

                    </a>
                </div>
            </header>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js